import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from 'src/app/core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class MobileAgentService {
  constructor(
    private readonly auth: AuthService,
    private deviceService: DeviceDetectorService
  ) {
    console.log('Init Mobile Agent Service');
  }

  public isMobileAgent(): boolean {
    return this.auth.getPermission('Perfil de Agent Mobile');
  }

  public isMobileDevice(): boolean {
    // return true; //Quitar comentario para hacer pruebas  
    return this.deviceService.isMobile();
  }
}
